// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import throttle from 'lodash/throttle'
import axios from 'axios'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-19347115-1',
  router
})

const __svg__ = {
  path: './assets/svg/icons/**/*.svg',
  name: 'annualreview2018/static/svg/[hash].icons.svg'
}
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__)

Vue.config.productionTip = false

Vue.prototype.$globals = Object.freeze({
  width: 768,
  mqMenu: window.matchMedia(`(min-width: 48em)`),
  contact: 'annualreview@ukpowernetworks.co.uk',
  focusColors: [
    ['purple', 'dark-purple'],
    ['blue', 'teal'],
    ['ukpn-red', 'dark-red'],
    ['dark-grey-tint', 'dark-grey'],
    ['ukpn-orange', 'ukpn-red'],
    ['light-green', 'dusty-green'],
    ['cyan-blue', 'navy-blue'],
    ['red', 'ukpn-red'],
    ['mojito-green', 'dark-green']
  ]
})

router.beforeEach((to, from, next) => {
  const base = 'UK Power Networks Annual Review 2018'
  document.title = (to.meta.title) ? base + ' | ' + to.meta.title : base
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  render: h => h(App),
  methods: {
    resized () {
      this.$store.commit('setWidth', window.innerWidth)
    },
    menuSwitch () {
      // console.log(this.$globals.mqMenu.matches)
      store.commit('setMobileMenu', !this.$globals.mqMenu.matches)
      store.commit('setMenu', false)
    },
    fetchData () {
      // axios.get('http://localhost:8000/api-v2')
      axios.get('/annualreview2018/static/content.json')
      // axios.get('http://ukpn-admin.trafiqdev.co.uk/api-v2')
        .then((response) => {
          const data = this.alterData(response.data)
          this.$store.commit('setContent', data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    alterData (data) {
      // Focus
      data.focus.forEach((item, index) => {
        item.color = this.$globals.focusColors[index]
      })
      return data
    }
  },
  created () {
    this.fetchData()
    this.menuSwitch()
    this.$globals.mqMenu.addListener(this.menuSwitch)
    this.resized()
    this.resizeHandler = throttle(() => this.resized(), 200)
    window.addEventListener('resize', this.resizeHandler)
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeHandler)
  }
})



// WEBPACK FOOTER //
// ./src/main.js